import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  minimal?: boolean;
  noTitle?: boolean;
}


import { faXmark } from '@icons/solid/faXmark';
import { faArrowDownLeftAndArrowUpRightToCenter } from '@icons/solid/faArrowDownLeftAndArrowUpRightToCenter';
import { faArrowUpRightAndArrowDownLeftFromCenter } from '@icons/solid/faArrowUpRightAndArrowDownLeftFromCenter';

import { useModal } from './modal-state';

const __default__ = { name: 'ModalHeader' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    minimal: { type: Boolean },
    noTitle: { type: Boolean }
  },
  setup(__props: any) {

/** `ModalHeader` component properties. */


const modal = useModal();

return { __sfc: true,modal, faXmark, faArrowDownLeftAndArrowUpRightToCenter, faArrowUpRightAndArrowDownLeftFromCenter }
}

})